import { render, staticRenderFns } from "./ServiceOrderWarnings.vue?vue&type=template&id=f1b41fd6&"
import script from "./ServiceOrderWarnings.vue?vue&type=script&lang=ts&"
export * from "./ServiceOrderWarnings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports